import React from "react";

import { LocaleProvider } from "./src/context/locale";

export const wrapPageElement = ({ element, props }) => {
  const { localisation, availableLocalisations } = props.pageContext;

  return (
    <LocaleProvider localisation={localisation} availableLocalisations={availableLocalisations}>
      {element}
    </LocaleProvider>
  );
};
